/** Admin SPA route; set REACT_APP_ADMIN_PATH at build time (e.g. /bp-a7f3c9d2). */
function normalizeAdminPath() {
  const raw = process.env.REACT_APP_ADMIN_PATH;
  if (!raw || typeof raw !== "string") return "/ctrl13";
  const t = raw.trim();
  if (!t.startsWith("/")) return "/ctrl13";
  const noTrail = t.replace(/\/+$/, "");
  return noTrail || "/ctrl13";
}

export const ADMIN_PATH = normalizeAdminPath();
